import { render, staticRenderFns } from "./PicklsInsights.vue?vue&type=template&id=3621ce2b&"
import script from "./PicklsInsights.vue?vue&type=script&lang=js&"
export * from "./PicklsInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3621ce2b')) {
      api.createRecord('3621ce2b', component.options)
    } else {
      api.reload('3621ce2b', component.options)
    }
    module.hot.accept("./PicklsInsights.vue?vue&type=template&id=3621ce2b&", function () {
      api.rerender('3621ce2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/Reports/PicklsInsights.vue"
export default component.exports